import { cn, hasValue  } from '@woonstad/helpers-utils';
import { ReactElement, type ReactNode } from 'react';

import DirectionsExtern from '../../icons/directions/Extern';
import { TextLink } from '../buttons/TextLink';
import { Typography } from '../typography/Typography';
import { PopoverClose, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from './PopoverPrimitives';

export interface PopoverProps {
  trigger: (title: string) => ReactNode;
  title: string;
  link?: ReactElement;
  children?: ReactNode;
  modal?: boolean;
}

export function Popover(props: PopoverProps) {
  return (
    <PopoverRoot modal={props.modal ?? true}>
      <PopoverTrigger asChild>
        {props.trigger(props.title)}
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          collisionPadding={16}
          className={cn('custom-scrollbar scrollbar-dark max-w-[calc(100vw-2rem)] overflow-auto border-none bg-popover p-4 pt-0 shadow-small sm:max-w-[30rem]', props.link && 'pb-0')}
        >
          <div className="sticky top-0 flex justify-between bg-popover py-4">
            <Typography
              variant="label-large"
              type="h3"
              className="text-popover-title"
            >
              {props.title}
            </Typography>
            <PopoverClose />
          </div>
          <div className="my-2 mb-6 text-popover-title">
            {props.children}
          </div>
          {hasValue(props.link) && (
            <div className="sticky bottom-0 w-full bg-popover py-4">
              <TextLink
                iconRight={DirectionsExtern}
                size="small"
              >
                {props.link}
              </TextLink>
            </div>
          )}
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>
  );
}
